// src/components/Home.js
import Content from './content';
import Section from './Section';
import Another from './Another';
import Testimonials from './Testimonials';
import Form from './Form';

function Home() {
  return (
    <>
      <Content />
      <Section />
      <Another />
      <Testimonials />
      <Form />
    </>
  );
}

export default Home;